import { IdentificationType } from '../common/components/IdentificationItems.tsx';
import { LicensePlateType } from 'dg-web-shared/dto/LicensePlateType.ts';
import { Message } from 'dg-web-shared/lib/Localized.ts';
import { Ticket } from 'dg-web-shared/model/Ticket.ts';

export type BarrierGateIdentificationEntity =
    | BarrierGateIdentificationBadge
    | BarrierGateIdentificationLicensePlate
    | BarrierGateIdentificationQrCode
    | BarrierGateIdentificationTicket;

export type BarrierGateIdentificationBadge = {
    identificationMedia: IdentificationType.BADGE;
    labelNr: string;
    rfidDecimal: string;
};

export type BarrierGateIdentificationLicensePlate = {
    identificationMedia: IdentificationType.LICENSE_PLATE;
    licenseNumber: string;
    countryCode: string | null;
    licenseGroup: LicensePlateType;
};

export type BarrierGateIdentificationQrCode = {
    identificationMedia: IdentificationType.QR_CODE;
    qrCodeId: string;
};

export type BarrierGateIdentificationTicket = {
    identificationMedia: IdentificationType.TICKET;
    ticket: Ticket;
};

export const enum OffstreetTransactionActions {
    RECODE = 'RECODE',
    REIMBURSE_CUSTOMER = 'REIMBURSE_CUSTOMER',
    DOWNLOAD_RECEIPT = 'DOWNLOAD_RECEIPT',
    CANCEL_ENTRY = 'CANCEL_ENTRY',
    DISABLE_ANTIPASSBACK = 'DISABLE_ANTIPASSBACK',
    GENERATE_GUEST_PERMIT = 'GENERATE_GUEST_PERMIT',
}

export enum ApprovingContractType {
    PERMIT = 'PERMIT',
    PRODUCT = 'PRODUCT',
}

export interface ApprovingContractInfo {
    approvingContractType: ApprovingContractType;
    infoText: Message;
    approvingContractExternalId: string;
    linkApprovingContract: boolean;
    isGuestProduct: boolean;
}

export interface PassageInfo {
    time: string;
    annotation: string | null;
}
